/**
 * Create a function that warns when someone uses style or className prop without giving reasoning
 *
 * @param props - props available on component
 * @param propName - propName
 * @param componentName - the name of component
 * @returns return error if styleOverrideReason is not provided
 */
export default (props, propName, componentName) => {
  if (props.className && typeof props.className !== 'string') {
    throw new Error('Required prop className needs to be of type string.');
  }

  if (props.style && typeof props.style !== 'object') {
    throw new Error('Required prop style needs to be of type object.');
  }

  if (process.env.NODE_ENV === 'development') {
    if ((props.style || props.className) && !props.styleOverrideReason) {
      throw new Error(
        'Required prop styleOverrideReason needed if style or className is provided in ',
        componentName,
        '.'
      );
    }

    if (
      (props.className || props.style) &&
      typeof props.styleOverrideReason !== 'string'
    ) {
      throw new Error(
        'Required prop styleOverrideReason needs to be of type string.'
      );
    }
  }

  return null;
};
